var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('QScoreCard',{key:"QScoreCardResets",attrs:{"agent-code":_vm.agentCode,"filters":_vm.filters,"title":"Resets","api-endpoint":"resets","drill-downLabel":"Agent Breakdown","drill-down-route":"Drilldown_Resets","card-style":"production","format":"Currency"}},[_vm._v(" Note: APV is the split percentage of the resetting agent. ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }